/**
 * PAPPO — Entry Point
 * Monta a aplicação React no DOM e regista o Service Worker.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

/* Montar aplicação */
const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

/* Registar Service Worker para PWA */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[PAPPO] Service Worker registado:', reg.scope);
      })
      .catch((err) => {
        console.warn('[PAPPO] Falha ao registar SW:', err);
      });
  });
}
